import { CreditCardForm } from '~/components/CreditCardForm'

import { useRechargeForm } from '../../../../../hooks/useRechargeForm'

/**
 * Seção de cartão de crédito que usa strategy pattern
 * para renderizar o formulário correto baseado no provider
 */
const CreditCardSection = () => {
  const { handleChangeCardForm, formRef } = useRechargeForm()

  return <CreditCardForm onChange={handleChangeCardForm} formRef={formRef} />
}

export default CreditCardSection
